import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import { getOneBundleOnePrefab } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import { cooperativeShopInterface, cooperativeShopSaveItem } from "./cooperativeConst";

const {ccclass, property} = cc._decorator;

@ccclass
export default class cooperativeShopItem extends cc.Component {

    @property({type:cc.Node,displayName:'视频图标'})
    videoIcon:cc.Node = null;

    @property({type:cc.Label,displayName:"描述文本"})
    lbExplain:cc.Label = null;

    @property({type:cc.Label,displayName:'名字文本'})
    lbName:cc.Label = null;

    @property({type:cc.Label,displayName:"有效时间文本"})
    lbTime:cc.Label = null;

    data:cooperativeShopInterface = null;

    videoFlag:number = 0;

    selectFun:(node:cc.Node)=>void;

    bindData(data:cooperativeShopInterface,selectFun:(node:cc.Node)=>void){
        this.data = data;
        this.selectFun = selectFun;
        this.updateItem();
    }

    updateItem(){
        if(!this.data){
            console.debug("#cooperativeShopItem @updataItem 没有数据,请检查配置表")
            return;
        }
        let hasAry:cooperativeShopSaveItem[] = NormalGameManager._instance.getGameData().hasShopCooperativeData;

        let index = hasAry.find(value=>{
            return this.data.id == value.id;
        });

        if(index){
            // 已经办理过了  视频图标隐藏
            this.videoFlag = 2;
        }else{
            // 没有办理过  判断当前数据中的videoFlag 如果是需要看视频的就看视频。不需要看视频的则不看视频直接进入
            if(this.data.videoFlag){
                this.videoFlag = 1;
            }else{
                this.videoFlag = 0;
            }
        }
        this.videoIcon.active = this.videoFlag == 1;
        this.lbName.string = this.data.name;
        this.lbExplain.string = this.data.explain;
        this.lbTime.string = `有效时间：${this.data.vaildHour}小时`;
    }

    onBtnMe(){
        // 点击开店
        if(this.videoFlag != 1){
            this.onEnterOnePrefab(false);
            this.selectFun && this.selectFun(this.node);
        }else{
            utilsModel.loadAndShowVideoAdTrans(()=>{
                // 办理一个开店
                NormalGameManager._instance.addOneCooperativeById(this.data.id);
                this.updateItem();
                this.onEnterOnePrefab(true);
                this.selectFun && this.selectFun(this.node);
            },()=>{},null,"看视频开店");
        }
    }

    async onEnterOnePrefab(isVideo:boolean){
        let param = this.data.param["openPrefab"];
        let bundleName = param["bundle"];
        let prefabPath = param["prefabPath"];

        // console.log(bundleName,prefabPath,"怎么回事??????",this.data,isVideo)

        if(bundleName && prefabPath)
        {
            // 打开某一个预制体
            let prefab = await getOneBundleOnePrefab(bundleName,prefabPath);
            let node:cc.Node = cc.instantiate(prefab);
            node.setParent(O1HD.Canvas());
            O1HD.emit("cooperativeShopLoadPage",isVideo);
        }
        // this
    }

}
